import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let tokenGetter = null;
export const setTokenGetter = (fn) => {
  tokenGetter = fn;
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    try {
      const t = await tokenGetter();
      if (t) config.headers.Authorization = `Bearer ${t}`;
    } catch (e) {
      /* signed out */
    }
  }
  return config;
});

export const errMsg = (e, fallback = "Algo salió mal. Intenta de nuevo.") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message === "Network Error" ? "Sin conexión con el servidor" : fallback;
  if (typeof d === "string") return d;
  if (d.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const errCode = (e) => e?.response?.data?.detail?.code;

export const fmtUSD = (n) =>
  new Intl.NumberFormat("es-SV", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const fmtUSD2 = (n) =>
  new Intl.NumberFormat("es-SV", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export const monthLabel = (ym) => {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  return d.toLocaleDateString("es-SV", { month: "short" });
};

export const fmtDate = (iso, opts = { day: "2-digit", month: "short" }) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-SV", opts);
  } catch {
    return "—";
  }
};

export const fmtRel = (iso) => {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "hace un momento";
  if (diff < 3600) return `hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `hace ${Math.floor(diff / 3600)} h`;
  return `hace ${Math.floor(diff / 86400)} d`;
};

export const toDateInput = (iso) => (iso ? iso.slice(0, 10) : "");
export const fromDateInput = (v) => (v ? new Date(`${v}T15:00:00Z`).toISOString() : null);
